import { SwitchInput, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { TTicketAutoFinishRuleForm } from "./TicketAutoFinishRuleSchema";

const translationPath = "page.settings.crm.ticketAutoFinishRules.";

export const FinishType = memo(() => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<TTicketAutoFinishRuleForm>();

  const finish = useWatch({ control, name: "finish" });
  const endOfDay = useWatch({ control, name: "endOfDay" });

  useEffect(() => {
    if (finish) {
      setValue("endOfDay", false);
    }
  }, [finish]);

  useEffect(() => {
    if (endOfDay) {
      setValue("finish", false);
    }
  }, [endOfDay]);

  return (
    <Grid item xs={12} sm={12}>
      <SwitchInput name="finish" label={t(translationPath + "finish_rule")} />
      <SwitchInput name="endOfDay" label={t(translationPath + "end_of_day")} />
    </Grid>
  );
});
